export default __webpack_public_path__ + "static/media/H.66e612cf.png";